import * as React from "react"
import H2 from "../../../atoms/typography/H2"
import { HorizontalSpacer, Spacer } from "../../../atoms/spacers"
import H3 from "../../../atoms/typography/H3"
import BodyMedium from "../../../atoms/typography/BodyMedium"
import styled from "styled-components"
import { MailIcon } from "../../../atoms/icons/MailIcon"
import { Row } from "react-grid-system"
import { ContactPhoneIcon } from "../../../atoms/icons/ContactPhoneIcon"

const IconTextFlex = styled.div`
  display: flex;
  align-items: center;
`

const SupportInfo: React.FC = () => {
  return (
    <div>
      <H2>Need support?</H2>
      <HorizontalSpacer spacing={2} />
      <H3>Contact us directly at:</H3>
      <HorizontalSpacer spacing={1} />
      <Row justify="between" align="center" nogutter>
        <a href="mailto:sales@satcube.com">
          <IconTextFlex>
            <MailIcon />
            <Spacer spacing={0.5} />
            <BodyMedium>sales@satcube.com</BodyMedium>
          </IconTextFlex>
        </a>
        <a href="tel:0046317010500">
          <IconTextFlex>
            <ContactPhoneIcon />
            <Spacer spacing={0.5} />
            <BodyMedium>+46 31 701 05 00 (intl)</BodyMedium>
          </IconTextFlex>
        </a>
      </Row>

      <HorizontalSpacer spacing={1.5} />
      <a href="tel:0018886175180">
        <IconTextFlex>
          <ContactPhoneIcon />
          <Spacer spacing={0.5} />
          <BodyMedium>+1 888 6175 180 (US)</BodyMedium>
        </IconTextFlex>
      </a>
    </div>
  )
}

export default SupportInfo
